import { render, staticRenderFns } from "./RenewalsLog.vue?vue&type=template&id=02aaa1b9"
import script from "./RenewalsLog.vue?vue&type=script&lang=js"
export * from "./RenewalsLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports